import { useScrollReveal } from '@/hooks/useScrollAnimations';
import { Printer, Layers, Box, PenTool, Coffee, Diamond, ArrowRight } from 'lucide-react';

const services = [
  { icon: Printer, title: 'DTG Printing', desc: 'Direct-to-garment printing for vibrant, photo-quality designs on any fabric.' },
  { icon: Layers, title: 'Sublimation', desc: 'Full-color sublimation printing for jerseys, sportswear, and promotional items.' },
  { icon: Box, title: '3D Sublimation', desc: 'Advanced 3D sublimation for curved surfaces, phone cases, and specialty items.' },
  { icon: PenTool, title: 'Monogram', desc: 'Elegant monogramming and embroidery for uniforms, towels, and corporate wear.' },
  { icon: Coffee, title: 'Mug Press', desc: 'Custom branded mugs, tumblers, and drinkware for gifts and promotions.' },
  { icon: Diamond, title: 'Rhinestone', desc: 'Sparkling rhinestone designs for fashion, events, and statement pieces.' },
];

const Services = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="services" className="py-24 bg-background">
      <div ref={ref} className="container mx-auto px-4">
        <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <span className="text-primary font-semibold text-sm uppercase tracking-widest">What We Do</span>
          <h2 className="text-3xl md:text-5xl font-bold font-display mt-3 text-foreground">Our Services</h2>
          <p className="text-muted-foreground mt-4 max-w-xl mx-auto">Premium branding solutions tailored for schools, corporates, and individuals.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((s, i) => (
            <a
              key={s.title}
              href="#contact"
              className={`group relative bg-card border border-border rounded-xl p-8 transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 hover:border-primary/30 cursor-pointer block ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: isVisible ? `${i * 100}ms` : '0ms' }}
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                <s.icon className="w-7 h-7 text-primary group-hover:text-primary-foreground transition-colors" />
              </div>
              <h3 className="text-xl font-bold font-display text-foreground mb-3">{s.title}</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">{s.desc}</p>
              <span className="inline-flex items-center text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                Get a quote <ArrowRight className="w-4 h-4 ml-1" />
              </span>
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-primary-glow rounded-b-xl scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
